import React from 'react'

import { Banner, Button } from '~components/internal'
import { colors } from '~tokens/internal'

import { formatRemaining } from './formatRemaining'

interface SessionExpiryBannerProps {
  remainingMs: number
  onSignOutNow: () => void
}

const SessionExpiryBanner: React.FC<SessionExpiryBannerProps> = ({ remainingMs, onSignOutNow }) => {
  return (
    <Banner
      type='warning'
      variant='standard'
      icon='warning'
      body={`You'll be signed out in ${formatRemaining(
        remainingMs,
      )}. Unsaved work on this page will be restored when you sign back in.`}
      action={
        <Button variant='link' onClick={onSignOutNow}>
          Sign out now
        </Button>
      }
      sx={{
        borderRadius: 0,
        backgroundColor: colors.orange[100],
        color: colors.orange[800],
      }}
    />
  )
}

export default SessionExpiryBanner
